import { MainGraph } from "./graph/Graph";
import "./style.css";
import { LearneyInfoController } from "./ui/LearneyInfoController";

function main() {
    const mainGraph = new MainGraph();
    const learneyinfoController = new LearneyInfoController();
}


main();